import React from 'react';
import { Box, Button } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { LOG_IN, SKIP } from 'common/constants/process-management';
import { useStore } from 'common/store';
import { SecurePortalParams } from 'common/types/reactRouter';
import { UseStoreValues } from 'common/types/store';
import { PMActionButtonsProps } from './ProcessManagementComponents.props';

const PMActionButtons = ({ handleOnClick }: PMActionButtonsProps) => {
  const { processType, requestId, hmacToken } = useParams<SecurePortalParams>();
  const [{ user }] = useStore() as unknown as UseStoreValues;
  const navigate = useNavigate();

  const sharedStyles = {
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: '1.125rem',
    padding: '1rem 2rem',
  };

  if (user) {
    navigate(`/${processType}/requests/${requestId}/${hmacToken}/portal`);
  }

  return (
    <Box
      style={{
        marginTop: '2rem',
      }}>
      <Button
        variant="contained"
        color="primary"
        style={{ ...sharedStyles, marginRight: '0.7rem' }}
        size="large"
        onClick={handleOnClick}>
        {LOG_IN}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        style={sharedStyles}
        size="large"
        component={Link}
        to={`/${processType}/requests/${requestId}/${hmacToken}/portal`}>
        {SKIP}
      </Button>
    </Box>
  );
};

export default PMActionButtons;
